import "../../assets/styles/style_pgi.scss";
import React, { useEffect, useState } from "react";
import Table from "../../components/pgi/Table";
import useCliente from "../../hooks/useCliente";
import { toast } from "react-hot-toast";
import { BulletList } from 'react-content-loader'

const Usuarios = () => {
  const [filterText, setFilterText] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const { getUsersCSV } = useCliente();

  useEffect(() => {
    const getUsers = async () => {
      try {
        const response = await getUsersCSV();
        setUsers(response);
      } catch (error) {
        setLoading(false);
        toast.error("Error al obtener usuarios");
      }finally {
        setLoading(false);
      }
    }
    getUsers();
  },[])

  const filterTextLowerCase = filterText?.toLowerCase();

  const filteredItems = users?.filter(
    (item) =>
      (item?.name.toLowerCase().includes(filterTextLowerCase)) ||
      item?.email.toLowerCase().includes(filterTextLowerCase)
  );

  const columnsTable = [
    {
      name: "ID",
      selector: (row) => row._id,
      sortable: true,
      maxWidth: "50px",
    },
    {
      name: "Nombre",
      selector: (row) => row.name,
      sortable: true,
      minWidth: "100px",
    },
    {
      name: "Profesión",
      selector: (row) => row.profession,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      minWidth: "100px",
    },
  ];

  const downloadCSV = (data, filename) => {
    const csv = convertToCSV(data);
    const csvData = new Blob([csv], { type: "text/csv" });
    
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(csvData, filename);
    } else {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(csvData);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  function convertToCSV(data) {
    const header = "_id,nombre,profesion,telefono,email";
    const rows = data.map(
      (obj) =>
        `${obj._id},${obj.name},${obj.profession},${obj.email}`
    );

    return `${header}\n${rows.join("\n")}`;
  }

  const exportToCSV = () => {
    downloadCSV(users, "usuarios.csv");
  };

  return (
    <section className="p-5 my-5 container containerPgi">
      <div className="d-md-flex justify-content-between container">
        <h2>Usuarios</h2>

        <div className="container-filter mt-2">
          <input
            onChange={(e) => setFilterText(e.target.value)}
            className="form-control input-filter"
            type="serch"
          />
          <button className="button-corralon-pgi" type="button">
            <span>Buscar</span>
          </button>
        </div>
      </div>
      {
        loading ? 
        <div className="skeletonContainer">
          <BulletList/>
        </div> 
        :
        <Table
          className={"marmoleria--datatable"}
          selectRows={false}
          columnsTable={columnsTable}
          filteredData={filteredItems?.length > 0 ? filteredItems : users}
          expandedRow={false}
          corralonesFilter={users}
          usersEnabled={true}
        />
      }
        <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center">
          <button
            className="button-corralon-pgi"
            type="button"
            onClick={exportToCSV}
          >
            <span>Descargar usuarios</span>
          </button>
        </div>
      </div>
    </section>
  )
};

export default Usuarios;
